import React, { useMemo } from 'react';
import {
  Form,
  FormProvider,
  CustomComponentProps,
  useFormNav,
  useFormContext,
} from '@updater/ui-informant';
import { Box, Button } from '@updater/ui-uds';
import { FormData } from './../types';
import styled from '@emotion/styled';
import { Mask } from '.';

const FromAddressContainer = styled(Box)`
  position: relative;
  display: block;
  margin-bottom: -16px;
`;

export const InnerForm: React.FC<CustomComponentProps> = (props) => {
  const { initialValue, onChange, schema } = props;
  return (
    <FormProvider
      initialValues={initialValue}
      onChange={onChange}
      schema={schema}
      submitComponent={
        <button type="submit" data-testid="inner-form-submit-button">
          Submit
        </button>
      }
      onSubmit={() => {}}
    >
      <Form />
    </FormProvider>
  );
};

export const FromOutsideCountryAddress: React.FC<CustomComponentProps> = (
  props
) => {
  const { goNext } = useFormNav();
  const { schema, onChange, initialValue } = props;
  const { values, errors } = useFormContext<FormData>();
  const memoized = useMemo(
    () => ({
      schema,
      initialValue,
      onChange,
    }),
    []
  );

  return (
    <FromAddressContainer mt="s">
      <Mask className="fadeIn">
        <Box>
          <InnerForm
            schema={memoized.schema}
            initialValue={
              values.fromOutsideCountryAddress ?? memoized.initialValue
            }
            onChange={memoized.onChange}
          />
          <Button
            data-testid="next-cta"
            className="next-cta"
            onClick={() => goNext()}
            size="l"
            variant="primary"
            isFluidWidth
            disabled={Boolean(errors.fromOutsideCountryAddress)}
            mt="m"
            mb="none"
          >
            Next
          </Button>
        </Box>
      </Mask>
    </FromAddressContainer>
  );
};
